// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const getSharedReportPathParamsSchema = z.object({
  uid: z.coerce.string().describe("Unique identifier of the shared report"),
});

/**
 * @description Shared report retrieved successfully
 */
export const getSharedReport200Schema = z.unknown();

/**
 * @description Shared report not found
 */
export const getSharedReport404Schema = z.unknown();

export const getSharedReportQueryResponseSchema = z.lazy(() => getSharedReport200Schema);
